import React, { useState } from "react";
import { Row, Col, Dropdown, Breadcrumb } from "react-bootstrap";
import {
  FiHome,
  FiFileText,
  FiCalendar,
  FiChevronUp,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import UserWelcomeCard from "../../../components/Dashboard/admin-dashboard/UserWelcomeCard";
import EmloyeesDashboardCards from "../../../components/Dashboard/admin-dashboard/EmloyeesDashboardCards";
import EmployeesDepartmentChart from "../../../components/Dashboard/admin-dashboard/EmployeesDepartmentChart";
import EmployeeStatusCard from "../../../components/Dashboard/admin-dashboard/EmployeeStatusCard";
import AttendanceOverviewCard from "../../../components/Dashboard/admin-dashboard/AttendanceOverviewCard";
import ClockInOutCard from "../../../components/Dashboard/admin-dashboard/ClockInOutCard";
import JobsApplicants from "../../../components/Dashboard/admin-dashboard/JobsApplicants";
import EmployeesCard from "../../../components/Dashboard/admin-dashboard/EmployeesCard";
import Todo from "../../../components/Dashboard/admin-dashboard/TodoCard";
import SalesOverview from "../../../components/Dashboard/admin-dashboard/SalesOverview";
import InvoicesCard from "../../../components/Dashboard/admin-dashboard/InvoicesCard";
import ProjectsCard from "../../../components/Dashboard/admin-dashboard/ProjectsCard";
import TasksStatisticsCard from "../../../components/Dashboard/admin-dashboard/TasksStatisticsCard";
import SchedulesCard from "../../../components/Dashboard/admin-dashboard/SchedulesCard";
import RecentActivitiesCard from "../../../components/Dashboard/admin-dashboard/RecentActivitiesCard";
import BirthdaysCard from "../../../components/Dashboard/admin-dashboard/BirthdayCard";
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default function AdminDashboardPage() {
  const [year, setYear] = useState(2025);
  const [selectedMonth, setSelectedMonth] = useState("Jan");

  return (
    <div
      style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }}
      className="page-breadcrumb mb-3"
    >
      <Row className="align-items-center justify-content-between">
        {/* LEFT SIDE */}
        <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Admin Dashboard
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Dashboard
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Admin Dashboard</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col md={6}>
          <div className="d-flex justify-content-md-end flex-wrap align-items-center">
            {/* EXPORT */}
            <Dropdown className="me-2 mb-2">
              <Dropdown.Toggle
                variant="light"
                className="btn-white tet-dark d-flex align-items-center text-dark export-btn"
              >
                <FiFileText className="me-1" />
                Export
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="p-2">
                <Dropdown.Item>Export as PDF</Dropdown.Item>

                <Dropdown.Item>Export as Excel</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* YEAR PICKER */}

            <Dropdown className="mb-2">
              <Dropdown.Toggle
                variant="light"
                className="year-picker d-flex align-items-center text-dark"
              >
                <FiCalendar className="me-2 " />
                {selectedMonth} {year}
              </Dropdown.Toggle>

              <Dropdown.Menu className="year-dropdown p-3">
                {/* YEAR HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <FiChevronLeft
                    style={{ cursor: "pointer" }}
                    onClick={() => setYear(year - 1)}
                  />

                  <strong>{year}</strong>

                  <FiChevronRight
                    style={{ cursor: "pointer" }}
                    onClick={() => setYear(year + 1)}
                  />
                </div>

                {/* MONTH GRID */}

                <div className="month-grid">
                  {months.map((m) => (
                    <div
                      key={m}
                      className={selectedMonth === m ? "month active" : "month"}
                      onClick={() => setSelectedMonth(m)}
                    >
                      {m}
                    </div>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>

            {/* COLLAPSE ICON */}

            {/* <div className="ms-2 mb-2">
              <button className="collapse-btn">
                <FiChevronUp />
              </button>
            </div> */}
          </div>
        </Col>
        <UserWelcomeCard />
        <Row>
          {/* Cards Section */}
          <Col xxl={8}>
            <EmloyeesDashboardCards className="d-flex" />
          </Col>

          {/* Graph Section */}
          <Col xxl={4}>
            <EmployeesDepartmentChart className="d-flex" />
          </Col>
        </Row>
        <Row className="g-3 ">
          <Col xl={4}>
            <EmployeeStatusCard />
          </Col>

          <Col xl={4} >
            <AttendanceOverviewCard />
          </Col>

          <Col xl={4} >
            <ClockInOutCard />
          </Col>
        </Row>

        <Row className="g-3  ">
          <Col xxl={4} xl={6}>
            <JobsApplicants className="d-flex" />
          </Col>

          <Col xxl={4} xl={6}>
            <EmployeesCard className="d-flex" />
          </Col>

          <Col xxl={4} xl={6}>
            <Todo className="d-flex" />
          </Col>
        </Row>
        <Row className="g-3  ">
          <Col xl={7}>
            <SalesOverview className="d-flex" />
          </Col>

          <Col xl={5}>
            <InvoicesCard className="d-flex" />
          </Col>
        </Row>
        <Row className="g-3  ">
          <Col xl={8} className="">
            <ProjectsCard className="d-flex" />
          </Col>

          <Col xl={4}>
            <TasksStatisticsCard className="d-flex" />
          </Col>
        </Row>

        <Row className="g-3  ">
          <Col xxl={4} xl={6} className="d-flex ">
            <SchedulesCard />
          </Col>

          <Col xxl={4} xl={6} className="d-flex">
            <RecentActivitiesCard />
          </Col>

          <Col xxl={4} xl={6} className="d-flex ">
            <BirthdaysCard />
          </Col>
        </Row>
      </Row>

      <style>
        {`
          .page-breadcrumb h2{
font-size:24px;
color:#1e293b;
}



.breadcrumb{
font-size:14px;
}

.breadcrumb-item + .breadcrumb-item::before{
content: ">";
color:#6b7280;
}

.btn-white{
background:#fff;
border:1px solid #e5e7eb;
padding:8px 14px;
font-size:14px;
}

.export-btn{
border-radius:6px;
}

.year-picker{
border:1px solid #e5e7eb;
background:#fff;
padding:8px 14px;
border-radius:6px;
font-size:14px;
}

.year-dropdown{
width:260px;
border-radius:10px;
box-shadow:0 8px 20px rgba(0,0,0,0.08);
}

.month-grid{
display:grid;
grid-template-columns:repeat(4,1fr);
gap:10px;
}

.month{
padding:8px;
text-align:center;
border-radius:6px;
cursor:pointer;
font-size:14px;
}

.month:hover{
background:#ff6b1a;
}

.month.active{
background:#0d6efd;
color:white;
}

.collapse-btn{
border:1px solid #e5e7eb;
background:#fff;
padding:8px 10px;
border-radius:6px;
}


@media (max-width:576px){
.task-card{
margin-top:15px;
}

.card-gap-mobile > div {
  margin-bottom: 1.5rem !important;
}

.card-gap-mobile > div:last-child {
  margin-bottom: 0 !important;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}

.card-gap-mobile > div {
  margin-bottom: 1.5rem !important;
}

.card-gap-mobile > div:last-child {
  margin-bottom: 0 !important;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}

          `}
      </style>
    </div>
  );
}
